// Styles
import './ErrorMessage.css'

const ErrorMessage = ({ message }) => {
  return (
    <div className='ErrorMessage-wrapper'>
      <span className='ErrorMessage-icon'>⚠️</span>
      <p className='ErrorMessage-text'>{message}</p>
    </div>
  )
}

export default ErrorMessage